import * as JsCookie from 'js-cookie'
import { SameSite } from '../enums/SameSite'

export class Cookie<ValueType> {
  private name: string
  private sameSite?: SameSite
  // TTL of cookie in seconds
  private maxAge?: number

  constructor({
    name,
    sameSite,
    maxAge
  }: {
    name: string
    sameSite?: SameSite
    maxAge?: number
  }) {
    this.name = name
    this.sameSite = sameSite ? sameSite : SameSite.strict
    this.maxAge = maxAge
  }

  set(value: ValueType): void {
    const options: any = {
      sameSite: this.sameSite
    }
    if (this.maxAge) {
      options['max-age'] = String(this.maxAge)
    }

    JsCookie.set(this.name, value, options)
  }

  get value(): ValueType {
    const value = JsCookie.get(this.name) || ''
    try {
      return JSON.parse(value) as any
    } catch {
      return value as any
    }
  }
}
